/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable camelcase */
import dutchMessages from 'ra-language-dutch'
import { StringMap } from 'react-admin'

export const i18nDutch: StringMap = {
  ...dutchMessages,
  resources: {
    tickets: {
      list: 'Meldingen',
      edit: 'Melding aanpassen',
      create: 'Melding aanmaken',
      title: 'Melding',
      contactPerson: 'Contactpersoon',
      sourceSystem: 'Bron systeem',
      caseDescription: 'Nieuwe melding starten voor zaaknummer %{name}',
      status: {
        INITIALISATIE: 'In afwachting',
        OPEN: 'Open',
        GESLOTEN: 'Gesloten',
      },
      requestStatus: {
        OPEN: 'Open',
        IN_BEHANDELING: 'In behandeling',
        GEWEIGERD: 'Geweigerd',
        INGETROKKEN: 'Ingetrokken',
        GEREEDGEMELD: 'Gereed gemeld',
        GEREED: 'Gereed',
      },
    },
    requests: {
      editStatus: 'Status aanpassen',
      editStatusDescription: 'Hier kun je de status en eventueel de melding van het actieverzoek aanpassen.',
      statusWarning: 'Let op: Er zijn beperkingen op het aanpassen van de status van een actieverzoek. ' +
      'Afhankelijk of je zender of ontvanger bent en de huidige status zijn bepaalde statusen niet beschikbaar. ' +
      'Een actieverzoek kan niet worden aangepast als de status GEREED, GEWEIGERD of INGETROKKEN is.',
    },
  },
  filters: {
    title: 'Filters',
    status: 'Status',
  },
  show: {
    details: 'Samenvatting',
    customer: 'Klant',
    documents: 'Documenten',
    requests: 'Actieverzoeken',
    notifications: 'Notificaties',
    noDocuments: 'Er zijn nog geen documenten toegevoegd',
  },
  data: {
    description: 'Beschrijving',
    createdAt: 'Aangemaakt op',
    nummerBinnenSysteem: 'Zaaknummer',
    closed: 'Gesloten',
    globaleLocatie: 'Globale locatie van het verzoek',
    sourceRequest: 'Bron verzoek',
    oloVerzoeknummer: 'OLO-verzoeknummer',
    oloRequestNumberHelperText: 'Het nummer van het OLO-verzoek. ' +
    'Kan niet worden gebruikt i.c.m. Verzoeknummer. ' +
    'Als het ingevuld is, moet bron verzoek OLO zijn of leeg worden gelaten.',
    requestNumberHelperText: 'Verzoeknummer van de samenwerking. ' +
    'Kan niet worden gebruikt i.c.m. OLO-verzoeknummer. ' +
    'Als het ingevuld is, moet bron verzoek DSO_LV zijn of leeg worden gelaten.',
    deadline: 'Deadline',
    productCode: 'Productcode',
    explanation: 'Toelichting',
    addRequest: 'Nieuw actieverzoek aanmaken',
    addRequestSubtitle: 'Hier kun je een nieuw actieverzoek toevoegen aan de samenwerking.',
    addDocument: 'Document toevoegen',
    addPartner: 'Ketenpartner toevoegen',
    complete: 'Sluiten',
    aangemaaktDoor: 'Aangemaakt door',
    contactpersoonNaam: 'Contactpersoon',
    startDate: 'Startdatum',
    collaborationForm: 'Samenwerkvorm',
    typeVerzoek: 'Type samenwerking',
    title: 'Titel',
    request: 'Actieverzoek',
    sender: 'Verzender',
    receiver: 'Ontvanger',
    privilegeInitiator: 'Initiator',
    inOrOut: 'In/Uit',
    confidentiality: 'Vertrouwelijkheid',
    by: 'Door',
    updated: 'Gewijzigd',
    date: 'Datum',
    type: 'Soort',
    noPartners: 'Nog geen ketenpartners uitgenodigd',
    confirmDeletePartner: 'Weet je zeker dat je deze ketenpartner wilt verwijderen?',
    partner: 'Ketenpartner',
    file: 'Bestand',
    access: 'Toegangsrecht',
    privilegeVT: 'Volledige',
    privilege: 'Beperkt',
    id: 'ID',
    name: 'Naam',
    purpose: 'Doel samenwerking',
    requestNumber: 'Verzoeknummer',
    phone: 'Telefoonnummer',
    email: 'E-mailadres',
    caseNumber: 'Zaaknummer',
    attachments: 'Bijlagen',
    status: 'Status',
  },
  login: {
    title: 'Inloggen',
    button: 'Inloggen',
    choose: 'Kies voor welke organisatie je wilt inloggen:',
    email: 'Email',
    emailHint: 'Vul je emailadres in om door te gaan.',
    fetchUserInfo: 'Een moment geduld, we halen je gebruikersinformatie op.',
    hint: 'Log in op xxllnc Supportpoc',
    incognitoError: 'Authenticatie niet mogelijk in incognito mode',
    loginCompleted: 'Succesvol ingelogd!',
    unknownOrganizationId: 'Het opgegeven organisatie-id is onbekend',
    notValid: 'Het opgegeven emailadres is niet geldig',
    byXxllnc: 'Supportpoc is een applicatie van xxllnc',
    inactive: 'Je bent uitgelogd vanwege inactiviteit.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Onbevoegd',
      defaultTitle: 'Onbevoegd',
      title: 'Voor deze actie ben je niet bevoegd.',
      text: 'Je hebt geprobeerd een actie uit te voeren waar je geen rechten voor hebt.',
    },
  },
  submenu: {
    settings: 'Beheer',
  },
}
